import React from 'react';

import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';

import { CardContainer } from '../styles';

export const UnlimitedFeeFreeTransfersCardEmpty = (props) => {
    return (
        <CardContainer>
            <Row indent="24px">
                <DiskBadge variant="primary" iconName="transfers" diskSize="fixed-small" />
            </Row>
            <Text variant="div" indent="16px">
                {props.title}
            </Text>
            <Text variant="div" color="secondary" indent="16px">
                {props.text}
            </Text>
            <Text
                variant="button"
                size="secondary"
                color="primary"
                onClick={() => {
                    props.openModal();
                }}
            >
                {props.learnMore}
            </Text>
        </CardContainer>
    );
};
